"use client";
import { Box, Typography } from "@mui/material";
import { AutoAwesome, ChevronLeft, ChevronRight } from "@mui/icons-material";
import React from "react";

interface WelcomeSlideProps {
  userName: string;
  year: number;
}

export default function WelcomeSlide({ userName, year }: WelcomeSlideProps) {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#0a0a0a",
        position: "relative",
        overflow: "hidden",
        color: "white",
        p: 4,
        textAlign: "center",
        "&::before": {
          content: '""',
          position: "absolute",
          top: "-50%",
          left: "-50%",
          width: "200%",
          height: "200%",
          background:
            "radial-gradient(circle, rgba(236, 72, 153, 0.3) 0%, rgba(6, 182, 212, 0.3) 50%, transparent 70%)",
          animation: "rotate 20s linear infinite",
        },
        "@keyframes rotate": {
          "0%": {
            transform: "rotate(0deg)",
          },
          "100%": {
            transform: "rotate(360deg)",
          },
        },
      }}
    >
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <AutoAwesome
          sx={{
            fontSize: 80,
            mb: 4,
            background: "linear-gradient(135deg, #ec4899 0%, #06b6d4 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            animation: "pulse 2s ease-in-out infinite",
            "@keyframes pulse": {
              "0%, 100%": {
                transform: "scale(1) rotate(0deg)",
                opacity: 1,
              },
              "50%": {
                transform: "scale(1.1) rotate(180deg)",
                opacity: 0.8,
              },
            },
          }}
        />
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            mb: 2,
            animation: "fadeInUp 0.6s ease-out 0.2s both",
            "@keyframes fadeInUp": {
              "0%": {
                opacity: 0,
                transform: "translateY(20px)",
              },
              "100%": {
                opacity: 1,
                transform: "translateY(0)",
              },
            },
          }}
        >
          {userName}'s
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 900,
            mb: 1,
            background: "linear-gradient(135deg, #ec4899 0%, #06b6d4 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            animation: "fadeInUp 0.6s ease-out 0.4s both",
          }}
        >
          {year}
        </Typography>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 600,
            animation: "fadeInUp 0.6s ease-out 0.6s both",
          }}
        >
          Year in Review
        </Typography>
        <Box
          sx={{
            mt: 6,
            display: "flex",
            alignItems: "center",
            gap: 2,
            opacity: 0.7,
            animation:
              "fadeInBounce 1s ease-out 1.2s both, float 2s ease-in-out 2s infinite",
            "@keyframes fadeInBounce": {
              "0%": {
                opacity: 0,
                transform: "translateY(20px)",
              },
              "100%": {
                opacity: 0.7,
                transform: "translateY(0)",
              },
            },
            "@keyframes float": {
              "0%, 100%": {
                transform: "translateY(0)",
              },
              "50%": {
                transform: "translateY(-8px)",
              },
            },
          }}
        >
          <ChevronLeft sx={{ fontSize: 28 }} />
          <Typography variant="body1" sx={{ fontWeight: 500 }}>
            Tap left or right to navigate
          </Typography>
          <ChevronRight sx={{ fontSize: 28 }} />
        </Box>
      </Box>
    </Box>
  );
}
